import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
// import { NkConfirmDialogComponent } from './confirm-dialog.component';

@NgModule({
  // declarations: [NkConfirmDialogComponent],
  imports: [MatDialogModule, MatButtonModule, FormsModule, CommonModule],
})
export class NkConfirmDialogModule {}
